import { render, staticRenderFns } from "./LanguageSelectorItem.vue?vue&type=template&id=b5c352d0&scoped=true"
import script from "./LanguageSelectorItem.vue?vue&type=script&lang=js"
export * from "./LanguageSelectorItem.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelectorItem.vue?vue&type=style&index=0&id=b5c352d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c352d0",
  null
  
)

export default component.exports